<template>
  <div
    class="flex justify-between items-center border-b-1px border-gray-200 pb-6"
  >
    <h3 class="text-20 text-blue font-bold mb-0 leading-snug lg:text-24">
      {{ __('online_booking_title') }}
    </h3>

    <ListWeekButtons v-if="isLargeScreen" />
  </div>
</template>

<script>
import { useMediaQuery } from '@vueuse/core';
import ListWeekButtons from '@/components/Room/ListWeekButtons';

export default {
  components: {
    ListWeekButtons
  },
  setup() {
    const isLargeScreen = useMediaQuery('(min-width: 1024px)');
    return {
      isLargeScreen
    };
  }
};
</script>
